// eslint-disable-next-line @propertyfinder/rules/enum-format
export const enum LeadEmailFormStatechartEvent {
  /**
   * Happens when ready to send lead to backend
   */
  wantToSendLead = 'wantToSendLead',

  /**
   * Happens when lead was created on backend
   */
  leadCreateSucceeded = 'leadCreateSucceeded',

  /**
   * Happens when could not create lead on backend (validation errors will be present here)
   */
  leadCreateFailed = 'leadCreateFailed',

  /**
   * Happens when new user is successfully register
   * (via auto registration, new user object present here)
   */
  userSuccessfulyRegistered = 'userSuccessfulyRegistered',

  /**
   * Happens when auto registration failed
   */
  autoRegistrationFailed = 'autoRegistrationFailed',

  /**
   * Happens when user was already registered before
   * (user records are already present on backend)
   */
  userWasAlreadyRegistered = 'userWasAlreadyRegistered',

  /**
   * User is already logged in
   */
  userIsLoggedIn = 'userIsLoggedIn',

  /**
   * Google captcha value changed
   */
  captchaValueChanged = 'captchaValueChanged',

  leadRetryWithCaptcha = 'leadRetryWithCaptcha',
}
